import { Injectable, ErrorHandler } from '@angular/core';
import { IAngularError } from '@shared/types';

@Injectable()
export class ErrorHandlerMiddleware extends ErrorHandler {
  public constructor() {
    super();
  }

  public handleError(error: IAngularError): void {
    /**
     * call native 'handleError' method from the
     * angular 'ErrorHandler' class for saving default behaviour
     * FYI: Can be skipped on some condition
     */
    super.handleError(error);
  }
}
